import { render, staticRenderFns } from "./UsersPrivilegeNews.vue?vue&type=template&id=49c155d1&scoped=true&"
import script from "./UsersPrivilegeNews.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c155d1",
  null
  
)

export default component.exports